import { render } from "./PorKm.vue?vue&type=template&id=71eb8fdc&scoped=true"
import script from "./PorKm.vue?vue&type=script&lang=js"
export * from "./PorKm.vue?vue&type=script&lang=js"

import "./PorKm.vue?vue&type=style&index=0&id=71eb8fdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71eb8fdc"]])

export default __exports__